/**
 * Defines the possible types for an activity log record.
 * This corresponds to the 'log_name' from the API.
 */
export enum ActivityLogType {
  PRODUCT = 'product',
  CATEGORY = 'category',
  ORDER = 'order',
  ORDER_DOCUMENT = 'order_document',
  PROJECT = 'project',
  USER = 'user'
}

/**
 * Defines the event type for an activity log record.
 */
export enum ActivityLogEvent {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted'
}

/**
 * Interface for the 'causer' object (the user who performed the action).
 */
export interface ActivityLogCauserResponse {
  id: number;
  name: string;
}

/**
 * Interface for the main activity log entry as it comes from the API.
 */
export interface ActivityLogResponse {
  id: number;
  log_name: ActivityLogType;
  description: string;
  event: ActivityLogEvent;
  subject_type: string;
  subject_id: number;
  causer_type: string;
  causer_id: number;
  causer: ActivityLogCauserResponse | null;
  properties: {
    attributes: Record<string, any>;
  };
  created_at: string;
  updated_at: string;
}

/**
 * Interface for query parameters when fetching the activity log.
 */
export interface ActivityLogQueryParams {
  skip?: number;
  take?: number;
  controller?: AbortController;
}
